import axios from "axios";

const baseURL = "https://Bree-SallieBot.eniweb.com/api";
// const baseURL = "http://127.0.0.1:8002/api";

const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

const apiEndpoints = {
  getCoachData: "/bot",
  postUserMessage: "/bot",
  login: "/login"
};

export const fetchCoachData = async () => {
  try {
    if(document.cookie.indexOf('token=') == -1){
      document.cookie = `token=fake`;
    }
    const response = await api.get(apiEndpoints.getCoachData);
    return response.data;
  } catch (error) {
    console.error("Error fetching coach data:", error);
    throw error;
  }
};

export const postUserMessage = async (message) => {
  try {
    if(document.cookie.indexOf('token=') == -1){
      document.cookie = `token=fake`;
    }
    const response = await api.post(apiEndpoints.postUserMessage, {
      content: message,
    },
    {withCredentials: true}
    // {withCredentials: false}
    );
    return response.data;
  } catch (error) {
    console.error("Error posting user message:", error);
    throw error;
  }
};



export const loginPost = async (token) => {
  try {
    const response = await api.post(apiEndpoints.login, {
      token: token,
    });
    return response.data;
  } catch (error) {
    console.error("Error posting user message:", error);
    throw error;
  }

};